import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLinkedinIn,
  faTwitter,
  faFacebookF,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons';
import { faLocationDot, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const socials = [
  { icon: faLinkedinIn, href: 'https://in.linkedin.com/', label: 'LinkedIn' },
  { icon: faTwitter, href: 'https://x.com/', label: 'Twitter' },
  { icon: faFacebookF, href: 'https://facebook.com/', label: 'Facebook' },
  { icon: faInstagram, href: 'https://instagram.com/', label: 'Instagram' },
];

const Footer = () => {
  return (
    <footer className="border-t border-line bg-white/40">
      <div className="container-x py-16">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="grid h-10 w-10 place-items-center overflow-hidden rounded-xl bg-ink shadow-mark">
                <img src="/logo512.png" alt="Lotez" className="h-7 w-7 object-contain" />
              </span>
              <span className="font-display text-lg font-bold text-ink">
                Lotez Technologies
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-muted">
              A technology studio where modern aesthetics meet user-centric
              design. We build innovative solutions that look great and work
              seamlessly.
            </p>
            <div className="mt-6 flex gap-3">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-line bg-white/60 text-ink transition hover:border-brand hover:bg-brand hover:text-white"
                >
                  <FontAwesomeIcon icon={s.icon} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-display text-sm font-semibold uppercase tracking-[0.16em] text-ink">
              Navigation
            </h3>
            <ul className="mt-5 flex flex-col gap-3 text-sm">
              <li>
                <NavLink to="/" className="text-muted transition hover:text-ink">
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink to="/about" className="text-muted transition hover:text-ink">
                  About
                </NavLink>
              </li>
              <li>
                <HashLink
                  to="/#services"
                  className="text-muted transition hover:text-ink"
                >
                  Services
                </HashLink>
              </li>
              <li>
                <NavLink
                  to="/contact"
                  className="text-muted transition hover:text-ink"
                >
                  Contact
                </NavLink>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-display text-sm font-semibold uppercase tracking-[0.16em] text-ink">
              Contact
            </h3>
            <ul className="mt-5 flex flex-col gap-3 text-sm text-muted">
              <li className="flex items-center gap-3">
                <FontAwesomeIcon icon={faLocationDot} className="text-brand" />
                Hyderabad, Telangana, India
              </li>
              <li className="flex items-center gap-3">
                <FontAwesomeIcon icon={faEnvelope} className="text-brand" />
                <a href="mailto:hello@lotez.in" className="transition hover:text-ink">
                  hello@lotez.in
                </a>
              </li>
              <li className="flex items-center gap-3">
                <FontAwesomeIcon icon={faPhone} className="text-brand" />
                <a href="tel:+916303541414" className="transition hover:text-ink">
                  +91 6303541414
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-line pt-6 text-xs text-muted sm:flex-row">
          <p>&copy; {new Date().getFullYear()} Lotez Technologies. All rights reserved.</p>
          <div className="flex gap-6">
            <NavLink to="/terms-and-conditions" className="transition hover:text-ink">
              Terms &amp; Conditions
            </NavLink>
            <NavLink to="/privacy-policy" className="transition hover:text-ink">
              Privacy Policy
            </NavLink>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
